module.exports = __webpack_public_path__ + "static/media/1pic.bef1b104.png";